query PollAgentWorkItem($id: ID!) {
  agentWorkItem(id: $id) {
    id
    databaseId
    status
    result
    errorMessage
  }
}
